import Footer from "../components/Footer";
import Header from "../components/Header";
import { useConfigContext } from "../providers/ConfigProvider";
import parse from 'html-react-parser';

const Privacy = () => {
    const { privacy } = useConfigContext();

    return (
        <div className="container">
            <Header 
                backLink={{
                    link: "/",
                    text: "Tilbake til oversikt"
                }}
            />

            <div className="row justify-content-center mt-5 pb-5">
                <div className="col-lg-8">
                    {privacy && parse(privacy)}
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Privacy;